import axios from '@/libs/api.request'

/**
 * 获取列表
 * @returns {wx.RequestTask | never}
 */
export const getList = (params) => {
  return axios.request({
    url: 'activityManage/articleConfig/index',
    method: 'get',
    params: params
  })
}

/**
 * 获取列表
 * @returns {wx.RequestTask | never}
 */
export const getWindowsParams = () => {
  return axios.request({
    url: 'activityManage/articleConfig/getWindowsParams',
    method: 'get'
  })
}


/**
 * 删除数据
 */
export const del = (id) => {
  return axios.request({
    url: 'activityManage/articleConfig/del',
    method: 'get',
    params: {
      id: id
    }
  })
}


/**
 * 锁定/解锁
 */
export const lock = (id) => {
  return axios.request({
    url: 'activityManage/articleConfig/lock',
    method: 'get',
    params: {
      id: id
    }
  })
}

/**
 * 改变状态按钮
 * @param status
 * @param id
 * @returns {wx.RequestTask | never}
 */
export const changeStatus = (status, id) => {
  return axios.request({
    url: 'activityManage/articleConfig/changeStatus',
    method: 'get',
    params: {
      status: status,
      id: id
    }
  })
}

/**
 * 新增
 * @param data
 * @returns {wx.RequestTask | never}
 */
export const add = (data) => {
  return axios.request({
    url: 'activityManage/articleConfig/add',
    method: 'post',
    data
  })
}

/**
 * 编辑
 * @param data
 * @returns {wx.RequestTask | never}
 */
export const edit = (data) => {
  return axios.request({
    url: 'activityManage/articleConfig/edit',
    method: 'post',
    data
  })
}
